module.exports = __webpack_public_path__ + "static/media/moodboard-icon.19362bf8.svg";